
const API_BASE_URL = process.env.REACT_APP_API_URL
export const MAP_KEY = process.env.REACT_APP_MAP_KEY
const api_version = `${API_BASE_URL}api/v1/`
export const venueList = `${api_version}admin/venue/get-venue-list`
export const statusUpdate = `${api_version}admin/common/update-status`
export const mediaVenue = `${api_version}admin/venue/get-venue-media-list`
export const mediaVenueUser = `${api_version}admin/venue/get-uploaded-user-media-list`
export const mediaVenueAdd = `${api_version}admin/venue/venue-media-add`
export const eventMediaAdd = `${api_version}admin/venue/event-media-add`
export const mediaVenueUpdate = `${api_version}admin/venue/venue-media-update`
export const getEventWiseMedia = `${api_version}admin/venue/get-event-wise-media`
export const deleteEVentMedia = `${api_version}admin/venue/event-media-delete`
export const mediaVenueStatus = `${api_version}admin/venue/media-status-update`
export const mediaVenueDelete = `${api_version}admin/venue/delete-media`
export const reviewVenue = `${api_version}admin/venue/get-venue-review-list`
export const reviewVenueUpdate = `${api_version}admin/venue/review-update`
export const reviewVenueDelete = `${api_version}admin/venue/delete-review`
export const reviewVenueStatus = `${api_version}admin/venue/review-status-update`
export const venuePreferences = `${api_version}admin/venue/get-venue-preferences`
export const getPreferencesMasterData = `${api_version}admin/venue/get-preferences-master-data`
export const venuePreferencesAdd = `${api_version}admin/venue/set-venue-preferences`
export const venuePreferencesUpdate = `${api_version}admin/venue/update-venue-preferences`
export const venueSaveSlots = `${api_version}admin/venue/save-slots`
export const venueGetSlots = `${api_version}admin/venue/get-slots`


export const getClaimedChat = `${api_version}admin/venue/get-claimed-chat`




export const sendClaimMediaMessage = `${api_version}admin/venue/sent-claim-media-message`


export const claimMessageEdit = `${api_version}admin/venue/claim-message-edit`


export const claimMessageDelete = `${api_version}admin/venue/claim-message-delete`



export const claimedVenueUpdateStatus = `${api_version}admin/venue/claimed-venue-update-status`

export const claimMediaApprove = `${api_version}admin/venue/claim-media-approve-status`



export const reviewVenueStarAdmin = `${api_version}admin/venue/selected-star-rating-list`


export const reviewVenueStarAdminAdd = `${api_version}admin/venue/select-star-questions`
export const reviewVenueStarAdminUpdate = `${api_version}admin/venue/select-star-questions-update`
export const reviewVenueStarList = `${api_version}admin/venue/get-star-rating`

// sign
export const signIn = `${api_version}admin/auth/sign-in`
export const changePass = `${api_version}admin/auth/change-password`

export const listReason = `${api_version}admin/report/reason/list`
export const addReason = `${api_version}admin/report/reason/add`
export const updateReason = `${api_version}admin/report/reason/update`


// venue save
export const listVenueSaveReason = `${api_version}admin/venue/save-reason/list`
export const addVenueSaveReason = `${api_version}admin/venue/save-reason/add`
export const updateVenueSaveReason = `${api_version}admin/venue/save-reason/update`
export const getVenueListOfOwner = `${api_version}admin/venue/get-venue-list-of-owner`

export const loucaCoinList = `${api_version}admin/louca-coin/list`
export const loucaCoinSetting = `${api_version}admin/louca-coin/setting`

// Profile Types
export const listProfileTypes = `${api_version}admin/profile/list-profile-types`
export const activeProfileTypes = `${api_version}admin/profile/active-profile-types`
export const addProfileTypes = `${api_version}admin/profile/add-profile-type`
export const updateProfileTypes = `${api_version}admin/profile/edit-profile-type`
export const deleteProfileTypes = `${api_version}admin/profile/delete-profile-type`

// Event Types
export const listEventTypes = `${api_version}admin/event/list-event-types`
export const addEventTypes = `${api_version}admin/event/add-event-type`
export const updateEventTypes = `${api_version}admin/event/edit-event-type`
export const deleteEventTypes = `${api_version}admin/event/delete-event-type`

// create public user
export const createPublicUser = `${api_version}admin/auth/create-public-user`
export const publicUserUpdate = `${api_version}admin/auth/update-user`

export const userProfileMediaAdd = `${api_version}admin/profile/profile-media-add`
export const userProfileMediaDelete = `${api_version}admin/profile/profile-media-delete`
export const userProfileMediaGet = `${api_version}admin/profile/get-profile-wise-media`


//Exercise

export const datListExercise = `${api_version}admin/dating/exercise/list`
export const addDatExercise = `${api_version}admin/dating/exercise/add`
export const updateDatExercise = `${api_version}admin/dating/exercise/update`

//LoucaAvtars
export const listAvatars = `${api_version}admin/avatars/list`
export const addAvatars = `${api_version}admin/avatars/add`
export const updateAvatars = `${api_version}admin/avatars/update`
export const deleteAvatars = `${api_version}admin/avatars/delete-louca-avatar`

//LoucaAi
export const listAi = `${api_version}admin/louca-ai/list`
export const addAi = `${api_version}admin/louca-ai/add`
export const updateAi = `${api_version}admin/louca-ai/update`
export const deleteAi = `${api_version}admin/louca-ai/delete-louca-ai`

//star-rating
export const listRating = `${api_version}admin/rating/category-wise`
export const RatingListData = `${api_version}admin/rating/list`


//Quick Survey
export const addQuickSurveyCategory = `${api_version}admin/quick-survey/category/add`
export const listQuickSurveyCategory = `${api_version}admin/quick-survey/category/list`
export const updateQuickSurveyCategory = `${api_version}admin/quick-survey/category/update`
export const deleteQuickSurveyCategory = `${api_version}admin/quick-survey/category/delete`

export const addQuickSurveyQuestions = `${api_version}admin/quick-survey/questions/add`
export const listQuickSurveyQuestions = `${api_version}admin/quick-survey/questions/list`
export const updateQuickSurveyQuestions = `${api_version}admin/quick-survey/questions/update`
export const categoryWiseQuestion = `${api_version}admin/quick-survey/category-wise-question`
export const addVenueQuestion = `${api_version}admin/quick-survey/add-venue-question`
export const getVenueQuestion = `${api_version}admin/quick-survey/get-venue-question`
export const getSurveyAnswersByVenue = `${api_version}admin/quick-survey/get-survey-answers-by-venue`

export const addRating = `${api_version}admin/rating/add`
export const updateRating = `${api_version}admin/rating/update`
export const deleteRating = `${api_version}admin/rating/delete-star-rating`

export const uploadImage = `${api_version}user/upload/upload-image`
export const venueStatusUpdate = `${api_version}admin/venue/status-update`
export const venueStatusDelete = `${api_version}admin/venue/delete-venue`
export const venueUpdate = `${api_version}admin/venue/update`
export const venueAdd = `${api_version}admin/venue/add`


export const datingProfile = `${api_version}admin/dating/get-dating-profile`





//user
export const userList = `${api_version}admin/user/get-user-list`
export const deleteUserAccount = `${api_version}admin/user/delete-user-account`
export const restoreUserAccount = `${api_version}admin/user/restore-user-account`
export const userPreferences = `${api_version}admin/user/get-user-preferences`
export const venueUploadedPhotos = `${api_version}admin/user/get-group-venue-uploaded-photos`
export const userUploadedVenuePhotos = `${api_version}admin/user/get-user-venue-uploaded-photos`

export const userCheckedInHistory = `${api_version}admin/user/get-user-venue-checked-in-history`

export const userCoinEarnHistory = `${api_version}admin/louca-coin/user-coin-earn-history`
export const userCoinReferEarnHistory = `${api_version}admin/louca-coin/user-refer-friend-coin-earn-history`
export const getUserReferralHistory = `${api_version}admin/user/get-user-referral-history`

export const getClaimedVenueList = `${api_version}admin/venue/get-claimed-venue-list`
export const getCountryStateCity = `${api_version}admin/venue/get-country-state-city`
export const userLoginHistory = `${api_version}admin/user/get-user-login-history`
export const getUserSearchHistory = `${api_version}admin/user/get-user-search-history`
export const userFriend = `${api_version}admin/user/get-user-friend-list`
export const datingFriendList = `${api_version}admin/user/get-dating-user-friend-list`
export const userFriendCount = `${api_version}admin/user/get-user-profile-details`
export const userCheckInOutLogs = `${api_version}admin/venue/get-check-in-out-logs`

// Feed
export const sharedFeed = `${api_version}admin/feed/shared-feed`
export const sharedFeedUserList = `${api_version}admin/feed/shared-feed-userList`

// Manage Dating
export const CurrentKids = `${api_version}admin/dating/kids/list`
export const CurrentKidsUpdate = `${api_version}admin/dating/kids/update`
export const CurrentKidsAdd = `${api_version}admin/dating/kids/add`

export const pronounsList = `${api_version}admin/dating/pronouns/list`
export const pronounsAdd = `${api_version}admin/dating/pronouns/add`
export const pronounsUpdate = `${api_version}admin/dating/pronouns/update`

export const occupationsList = `${api_version}admin/dating/occupations/list`
export const occupationsAdd = `${api_version}admin/dating/occupations/add`
export const occupationsUpdate = `${api_version}admin/dating/occupations/update`

export const ageGroupList = `${api_version}admin/dating/age-group/list`
export const ageGroupAdd = `${api_version}admin/dating/age-group/add`
export const ageGroupUpdate = `${api_version}admin/dating/age-group/update`

export const hairColorList = `${api_version}admin/dating/hair-color/list`
export const hairColorAdd = `${api_version}admin/dating/hair-color/add`
export const hairColorUpdate = `${api_version}admin/dating/hair-color/update`

export const heightList = `${api_version}admin/dating/height/list`
export const heightAdd = `${api_version}admin/dating/height/add`
export const heightUpdate = `${api_version}admin/dating/height/update`

export const bodyTypeList = `${api_version}admin/dating/body-type/list`
export const bodyTypeAdd = `${api_version}admin/dating/body-type/add`
export const bodyTypeUpdate = `${api_version}admin/dating/body-type/update`


// Venue Invites
export const sentVenueInvite = `${api_version}admin/venue/get-sent-venue-invite-list`
export const recivedVenueInvite = `${api_version}admin/venue/get-recived-venue-invite-list`

//  futureKids
export const futureKidsList = `${api_version}admin/dating/futureKids/list`
export const futureKidsUpdate = `${api_version}admin/dating/futureKids/update`
export const futureKidsAdd = `${api_version}admin/dating/futureKids/add`

//  analytics
export const analyticsUserSaveVenue = `${api_version}admin/analytics/user-save-venue`
export const analyticsUserFunnelVenue = `${api_version}admin/analytics/user-funnel-venue`
export const getOverallSummary = `${api_version}admin/analytics/get-overall-summary`
export const getDashboardGraph = `${api_version}admin/analytics/get-dashboard-graph`
export const getSentimentTrackingAi = `${api_version}admin/analytics/sentiment-tracking-ai`
export const getLiveDemoGraphGraph = `${api_version}admin/analytics/get-live-demo-graph-graph`
export const getLiveFootTraffic = `${api_version}admin/analytics/get-live-foot-traffic`
export const getCategoryScore = `${api_version}admin/analytics/category-score`
export const getRepeatVisitor = `${api_version}admin/analytics/repeat-visitor`
export const getVenueUserIntent = `${api_version}admin/analytics/venue-user-intent`
export const getVenueTopKeyWords = `${api_version}admin/analytics/top-keywords`
export const getLocalAreaTrends = `${api_version}admin/analytics/local-area-trends`
export const getEventVsNormalNight = `${api_version}admin/analytics/event-vs-normal-night`
export const getTimeOfDay = `${api_version}admin/analytics/time-of-day`
export const getOverAllSummeryForVenueOwner = `${api_version}admin/analytics/get-overall-summary-for-venueOwner`
export const getDashboardGraphForVenueOwner = `${api_version}admin/analytics/get-dashboard-graph-for-venueOwner`

// Drinking
export const drinkingList = `${api_version}admin/dating/drink/list`
export const drinkingAdd = `${api_version}admin/dating/drink/add`
export const drinkingUpdate = `${api_version}admin/dating/drink/update`

// Smoking
export const smokeList = `${api_version}admin/dating/smoking/list`
export const smokeAdd = `${api_version}admin/dating/smoking/add`
export const smokeUpdate = `${api_version}admin/dating/smoking/update`

//education
export const educationList = `${api_version}admin/dating/education/list`
export const educationAdd = `${api_version}admin/dating/education/add`
export const educationUpdate = `${api_version}admin/dating/education/update`

//quality
export const qualityList = `${api_version}admin/dating/quality/list`
export const qualityAdd = `${api_version}admin/dating/quality/add`
export const qualityUpdate = `${api_version}admin/dating/quality/update`

//hobbies
export const hobbiesList = `${api_version}admin/dating/hobby/list`
export const hobbiesAdd = `${api_version}admin/dating/hobby/add`
export const hobbiesUpdate = `${api_version}admin/dating/hobby/update`

//Night Prefrence
export const nightPrefrenceList = `${api_version}admin/dating/night-prefrence/list`
export const nightPrefrenceAdd = `${api_version}admin/dating/night-prefrence/add`
export const nightPrefrenceUpdate = `${api_version}admin/dating/night-prefrence/update`
//relation
export const relationList = `${api_version}admin/dating/relation/list`
export const relationAdd = `${api_version}admin/dating/relation/add`
export const relationUpdate = `${api_version}admin/dating/relation/update`

//genderman
export const manList = `${api_version}admin/dating/man/list`
export const manAdd = `${api_version}admin/dating/man/add`
export const manUpdate = `${api_version}admin/dating/man/update`

//genderWoman
export const womanList = `${api_version}admin/dating/woman/list`
export const womanAdd = `${api_version}admin/dating/woman/add`
export const womanUpdate = `${api_version}admin/dating/woman/update`

//genderNonBinary
export const binaryList = `${api_version}admin/dating/nonbinary/list`
export const binaryAdd = `${api_version}admin/dating/nonbinary/add`
export const binaryUpdate = `${api_version}admin/dating/nonbinary/update`

// Gender
export const genderList = `${api_version}admin/dating/gender/list`
export const genderAdd = `${api_version}admin/dating/gender/add`
export const genderUpdate = `${api_version}admin/dating/gender/update`

// Unrecognized

export const unrecognizedAi = `${api_version}admin/ai/get-unrecognized-query`
export const venuesCheckInOut = `${api_version}admin/venue/check-in-out/list`

export const venueInterestedDateWiseList = `${api_version}admin/venue/interested/get-date-wise-list`


export const claimMediaListVenue = `${api_version}admin/venue/claim-media-list`
export const mediMediaSubList = `${api_version}admin/venue/get-claim-media-user-list`
export const listActiveEventType = `${api_version}admin/event/list-active-event-types`;
export const addVenueEvent = `${api_version}admin/venue/add-venue-event`;
export const getVenueEvent = `${api_version}admin/venue/get-venue-event`;
export const updateVenueEvent = `${api_version}admin/venue/update-venue-event`;
export const updateVenueEventStatus = `${api_version}admin/venue/update-venue-event-status`;
export const getFollowingList = `${api_version}admin/user/get-following-list`;
export const getFollowerList = `${api_version}admin/user/get-follower-list`;
export const saveLegalContent = `${api_version}admin/legal-content/save-legal-content`;
export const getLegalContent = `${api_version}admin/legal-content/get-legal-content`;






/////prefereces

export const listDays = `${api_version}admin/preferences/days/list`
export const addDays = `${api_version}admin/preferences/days/add`
export const updateDays = `${api_version}admin/preferences/days/update`
export const daysStatus = `${api_version}admin/preferences/days/status`

export const listPrefAgeGroup = `${api_version}admin/preferences/age-group/list`
export const addPrefAgeGroup = `${api_version}admin/preferences/age-group/add`
export const updatePrefAgeGroup = `${api_version}admin/preferences/age-group/update`
export const statusPrefAgeGroup = `${api_version}admin/preferences/age-group/status`

export const listAlcohol = `${api_version}admin/preferences/alcohol/list`
export const addAlcohol = `${api_version}admin/preferences/alcohol/add`
export const updateAlcohol = `${api_version}admin/preferences/alcohol/update`
export const statusAlcohol = `${api_version}admin/preferences/alcohol/status`

export const listCraving = `${api_version}admin/preferences/craving/list`
export const addCraving = `${api_version}admin/preferences/craving/add`
export const updateCraving = `${api_version}admin/preferences/craving/update`
export const statusCraving = `${api_version}admin/preferences/craving/status`


export const listCrowds = `${api_version}admin/preferences/crowd/list`
export const addCrowds = `${api_version}admin/preferences/crowd/add`
export const updateCrowds = `${api_version}admin/preferences/crowd/update`
export const statusCrowds = `${api_version}admin/preferences/crowd/status`


export const listCuisine = `${api_version}admin/preferences/cuisine/list`
export const addCuisine = `${api_version}admin/preferences/cuisine/add`
export const updateCuisine = `${api_version}admin/preferences/cuisine/update`
export const statusCuisine = `${api_version}admin/preferences/cuisine/status`


export const listDietary = `${api_version}admin/preferences/dietary/list`
export const addDietary = `${api_version}admin/preferences/dietary/add`
export const updateDietary = `${api_version}admin/preferences/dietary/update`
export const statusDietary = `${api_version}admin/preferences/dietary/status`


export const listDJClubs = `${api_version}admin/preferences/dj-clubs/list`
export const addDJClubs = `${api_version}admin/preferences/dj-clubs/add`
export const updateDJClubs = `${api_version}admin/preferences/dj-clubs/update`
export const statusDJClubs = `${api_version}admin/preferences/dj-clubs/status`



export const listEntryFees = `${api_version}admin/preferences/entry-fees/list`
export const addEntryFees = `${api_version}admin/preferences/entry-fees/add`
export const updateEntryFees = `${api_version}admin/preferences/entry-fees/update`
export const statusEntryFees = `${api_version}admin/preferences/entry-fees/status`



export const listEventActivities = `${api_version}admin/preferences/event-activities/list`
export const addEventActivities = `${api_version}admin/preferences/event-activities/add`
export const updateEventActivities = `${api_version}admin/preferences/event-activities/update`
export const statusEventActivities = `${api_version}admin/preferences/event-activities/status`





export const listFoodPrice = `${api_version}admin/preferences/food-price/list`
export const addFoodPrice = `${api_version}admin/preferences/food-price/add`
export const updateFoodPrice = `${api_version}admin/preferences/food-price/update`
export const statusFoodPrice = `${api_version}admin/preferences/food-price/status`






export const listLiveMusic = `${api_version}admin/preferences/live-music/list`
export const addLiveMusic = `${api_version}admin/preferences/live-music/add`
export const updateLiveMusic = `${api_version}admin/preferences/live-music/update`
export const statusLiveMusic = `${api_version}admin/preferences/live-music/status`



export const listNonAlcohol = `${api_version}admin/preferences/non-alcohol/list`
export const addNonAlcohol = `${api_version}admin/preferences/non-alcohol/add`
export const updateNonAlcohol = `${api_version}admin/preferences/non-alcohol/update`
export const statusNonAlcohol = `${api_version}admin/preferences/non-alcohol/status`






export const listRegions = `${api_version}admin/preferences/regions/list`
export const addRegions = `${api_version}admin/preferences/regions/add`
export const updateRegions = `${api_version}admin/preferences/regions/update`
export const statusRegions = `${api_version}admin/preferences/regions/status`

export const listSpecials = `${api_version}admin/preferences/specials/list`
export const addSpecials = `${api_version}admin/preferences/specials/add`
export const updateSpecials = `${api_version}admin/preferences/specials/update`
export const statusSpecials = `${api_version}admin/preferences/specials/status`



export const listVenueTags = `${api_version}admin/preferences/venue-tag/list`
export const addVenueTags = `${api_version}admin/preferences/venue-tag/add`
export const updateVenueTags = `${api_version}admin/preferences/venue-tag/update`
export const statusVenueTags = `${api_version}admin/preferences/venue-tag/status`




export const listIntrestedIn = `${api_version}admin/preferences/intrested-in/list`
export const addIntrestedIn = `${api_version}admin/preferences/intrested-in/add`
export const updateIntrestedIn = `${api_version}admin/preferences/intrested-in/update`
export const statusIntrestedIn = `${api_version}admin/preferences/intrested-in/status`





export const listRelationshipStatus = `${api_version}admin/preferences/relationship-status/list`
export const addRelationshipStatus = `${api_version}admin/preferences/relationship-status/add`
export const updateRelationshipStatus = `${api_version}admin/preferences/relationship-status/update`
export const statusRelationshipStatus = `${api_version}admin/preferences/relationship-status/status`


export const signInVenue = `${api_version}admin/venue-owner/auth/sign-in`
export const createVenueOwner = `${api_version}admin/venue-owner/auth/create-venue-owner`
export const sendOtpEmail = `${api_version}admin/venue-owner/auth/email-send-otp`
export const verifyOtp = `${api_version}admin/venue-owner/auth/email-verify-otp`


export const getVenueBased = `${api_version}admin/venue-owner/venue/get-venue-based-filter`
export const saveVenueDocument = `${api_version}admin/venue-owner/venue/save-venue-owner-document`
export const getVenueOwnerList = `${api_version}admin/venue-owner/venue/get-owner-list`
export const venueAssignByAdmin = `${api_version}admin/venue-owner/venue/venue-assign-by-admin`
export const venueUnAssignByAdmin = `${api_version}admin/venue-owner/venue/venue-un-assign-by-admin`



